<template>

    <div>

        <section class="page-banner page-banner-sec">
            <h1 class="section-title">{{ $t('messages.header')}}</h1>
        </section>

        <div class="wrapper">

            <SideBar />

            <div id="content" class="col p-0">
                <router-view></router-view>
            </div>

        </div>

    </div>

</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { errHandler } from '@/lib/handlers'

export default {
    name: 'Messages',
    components: {
        SideBar: () => import('@/components/SideBar.vue')
    },
    mounted () {
        this.fetchFolders().then((v)=> {
            this.inboxRedirect();
        }).catch((err) => errHandler(err));
        this.fetchMatchings();
    },
    watch: {
        $route: function () {
            this.inboxRedirect();
        }
    },
    methods: {
        ...mapActions(['fetchFolders', 'fetchMatchings']),
        inboxRedirect () {
            // Redirect user to Inbox Listing
            if (this.$route.name == 'messages') {
                let inbox = (this.typeFolders(40)[0]) ? this.typeFolders(40)[0].id : 0;
                if (inbox > 0) this.$router.push({ name: 'messages.listing', params: { id: inbox } } );
            }
        }
    },
    computed: {
        ...mapGetters(['folders', 'typeFolders']),
    }
}
</script>
